import React, { useState } from 'react';
import { Alert, Button, Card, Form, Input, Space, Typography, } from 'antd';
import { useAuth } from "../../context/auth.context";
import { FormPage } from "../contents/form-page";

const { Title, Text } = Typography;

export const ForgotPassword: React.FC = () => {
  const [sentEmail, setSentEmail] = useState(false);
  const { forgotPassword } = useAuth();

  const onFinish = async ( values: any ) => {
    forgotPassword.execute({
      email: values.email
    })
      .then(() => setSentEmail(true))
      .catch(( error: any ) => {
        //
      });
  };

  return (
    <FormPage displayFooter={true}>
      <Space direction={'vertical'} size={'small'} className={'full-width'} style={{ width: '400px' }}>
        <Space direction={'vertical'} size={'small'}>
          <Title style={{ margin: 0 }} level={2}>
            Forgot Password
          </Title>
          <Text type={'secondary'}></Text>
        </Space>
        <Card>
          {forgotPassword?.error && (
            <Alert className={'alert'}
                   description="Please try again. If the problem persists, contact the site administrator"
                   type="warning"
            />
          )}
          {sentEmail && (
            <Alert
              className={'alert'}
              message="Please check your email for link to change password"
              type="success"
              data-cy="reset-password-message-text"
            />
          )}
          <Form
            name="normal_login"
            layout={'vertical'}
            requiredMark={false}
            className="forgot-password-form"
            initialValues={{ email: '' }}
            onFinish={onFinish}
          >
            <Form.Item
              name="email"
              label="Email"
              rules={[{ required: true, message: 'Please input your Email!' }]}
            >
              <Input
                size="large"
                type="email"
                placeholder="Email"
                disabled={sentEmail}
              />
            </Form.Item>

            <Space direction={'vertical'} className={'full-width'}>
              <a className="forgot-password-form-remember" href="/login">
                Remember password?
              </a>

              <Button
                type="primary"
                size="large"
                htmlType="submit"
                className="forgot-password-form-button full-width"
                disabled={sentEmail}
                loading={forgotPassword?.loading}
              >
                Send email
              </Button>
            </Space>
          </Form>
        </Card>
      </Space>
    </FormPage>
  );
};
